import {UserPermissionValue} from 'types';

const permission = (value: string) => `PERMISSION_${value}` as UserPermissionValue;

export const PERMISSION_ALIASES = {
    remarkingAuditLogView: permission('MPL_REMARKING_AUDIT_LOG_VIEW'),
    remarkingAuditLogExport: permission('MPL_REMARKING_AUDIT_LOG_EXPORT'),
    blockingAuditLogView: permission('MPL_BLOCKING_AUDIT_LOG_VIEW'),
    blockingAuditLogExport: permission('MPL_BLOCKING_AUDIT_LOG_EXPORT'),
    withdrawalAuditLogView: permission('MPL_WITHDRAWAL_AUDIT_LOG_VIEW'),
    withdrawalAuditLogExport: permission('MPL_WITHDRAWAL_AUDIT_LOG_EXPORT'),
    recallAuditLogView: permission('MPL_RECALL_AUDIT_LOG_VIEW'),
    productCardAuditLogView: permission('MPL_PRODUCT_CARD_AUDIT_LOG_VIEW'),
    productCardAuditLogExport: permission('MPL_PRODUCT_CARD_AUDIT_LOG_EXPORT'),
    returnAuditLogView: permission('MPL_RETURN_AUDIT_LOG_VIEW'),
    returnAuditLogExport: permission('MPL_RETURN_AUDIT_LOG_EXPORT'),
    appealAllList: permission('MPL_APPEAL_ALL_LIST'),
    appealList: permission('MPL_APPEAL_LIST'),
    appealCreate: permission('MPL_APPEAL_CREATE'),
    remarking: permission('MPL_REMARKING'),
    personnelNk: permission('MPL_PERSONNEL_NK'),
    nkBranchManage: permission('MPL_NK_BRANCH_MANAGE'),
    profileDataView: permission('MPL_PROFILE_DATA_VIEW'),
    registeredTurnoverParticipantsView: permission('MPL_ISEMT_USER_REG_TURNOVER_PARTICIPANTS_VIEW'),
    organizationRegister: permission('MPL_ISEMT_ORGANIZATION_REGISTER'),
    organizationEdit: permission('MPL_ISEMT_ORGANIZATION_EDIT'),
    allStoragesView: permission('MPL_ISEMT_USER_ALL_VIEW'),
    userOwnStoragesView: permission('MPL_ISEMT_USER_OWN_VIEW'),
    userOwnRegister: permission('MPL_ISEMT_USER_OWN_REGISTER'),
    userAllRegister: permission('MPL_ISEMT_USER_ALL_REGISTER'),
    userOwnEdit: permission('MPL_ISEMT_USER_OWN_EDIT'),
    userAllEdit: permission('MPL_ISEMT_USER_ALL_EDIT'),
    userEmployeeInfoView: permission('MPL_ISEMT_USER_EMPLOYEE_INFO_VIEW'),
    organizationParticipantOwnRegister: permission(
        'MPL_ISEMT_ORGANIZATION_PARTICIPANT_OWN_REGISTER',
    ),
    participantAllRegister: permission('MPL_ISEMT_PARTICIPANT_ALL_REGISTER'),
    participantOwnEdit: permission('MPL_ISEMT_PARTICIPANT_OWN_EDIT'),
    customsAuditLogView: permission('MPL_CUSTOMS_AUDIT_LOG_VIEW'),
    customsAuditLogExport: permission('MPL_CUSTOMS_AUDIT_LOG_EXPORT'),
} as const;

export type PermissionAlias = keyof typeof PERMISSION_ALIASES;
export type PermissionAliasMap = Record<PermissionAlias, UserPermissionValue>;
